export default __webpack_public_path__ + "static/media/gallery36_4.46e60076.png";